export default class GetConstructionSitesDataRequest {
    public organizationId: string | null = null;
}